import ContentStorage from '../../../tnew/content/ContentStorage';

function getValue(name: string) {
  return ContentStorage.getValue('9d81ee34-b291-11eb-8529-0242ac130003', name);
}

class DatePickerComponent {
  static get navigateByDayLabel() {
    return getValue('NavigateByDayLabel');
  }

  static get navigateByMonthLabel() {
    return getValue('NavigateByMonthLabel');
  }

  static get navigateByYearLabel() {
    return getValue('NavigateByYearLabel');
  }

  static get cancelLabel() {
    return getValue('CancelLabel');
  }

  static get helpText() {
    return getValue('HelpText');
  }
}

export default DatePickerComponent;
